import React, { ReactElement } from "react";
import useDispatchFeedback from "./useDispatchFeedback";
import useDispatchRichEdits from "./useDispatchRichEdits";

interface Props {
  editorId: number;
  editorElement: HTMLElement;
  shouldRefresh: boolean;
}

/**
 * Dispatches editing changes to redux, including
 *   - Updating updating underlines
 *   - Sending debounced, updated content to the server
 */
function EditingDispatcher({
  editorId,
  editorElement,
  shouldRefresh,
}: Props): ReactElement {
  useDispatchRichEdits(editorElement, editorId);
  useDispatchFeedback(
    editorElement,
    editorElement.outerHTML,
    editorId,
    shouldRefresh
  ); // refresh the feedback, debounced
  return <></>;
}

export default EditingDispatcher;
